module.exports = __webpack_public_path__ + "assets/img/120303.2ed98c7e.png";